export const somethingWrongText="Something went wrong, please try again!"
export const requiredText="This field is required!"
export const emailValitaionText="Invaild email address!"
export const contactNumberLengthText ='Contact number must be minimum 9 and maximum 11 digits!'
